import { createContext } from "react";

export const BatchOdesContext = createContext();
